import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=63b0cc3d&scoped=true"
import script from "./Pagination.ts?vue&type=script&lang=ts&external"
export * from "./Pagination.ts?vue&type=script&lang=ts&external"
import style0 from "./Pagination.vue?vue&type=style&index=0&id=63b0cc3d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b0cc3d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63b0cc3d')) {
      api.createRecord('63b0cc3d', component.options)
    } else {
      api.reload('63b0cc3d', component.options)
    }
    module.hot.accept("./Pagination.vue?vue&type=template&id=63b0cc3d&scoped=true", function () {
      api.rerender('63b0cc3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Core/components/Pagination/Pagination.vue"
export default component.exports